module.exports = __webpack_public_path__ + "static/media/giorgio-armani-si-intese-big.b3862f5a.png";